import { render } from "./ShopImageGallery.vue?vue&type=template&id=616729dd&scoped=true&ts=true"
import script from "./ShopImageGallery.vue?vue&type=script&lang=ts"
export * from "./ShopImageGallery.vue?vue&type=script&lang=ts"

import "./ShopImageGallery.vue?vue&type=style&index=0&id=616729dd&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616729dd"]])

export default __exports__